import { gql } from '@apollo/client';

export const EXECUTOR_FRAGMENT = gql`
  fragment ExecutorReturn on Executor {
    id
    createdAt
    updatedAt
    fullName
    category
    categories
    heavyTruckType
    driverLicensePhotos
    sorPhotos
    techniqueName
    techniquePhoto
    number
    status
    statusMessage
    workStatus
    completedOrders
    rating
    user {
      id
    }
  }
`;

export const ADMIN_EXECUTORS = gql`
  ${EXECUTOR_FRAGMENT}
  query ADMIN_EXECUTORS($where: AdminExecutorsWhereInput, $skip: Int, $take: Int) {
    adminExecutors(where: $where, skip: $skip, take: $take) {
      ...ExecutorReturn
    }
    adminExecutorsCount(where: $where)
  }
`;

export const ADMIN_EXECUTOR = gql`
  ${EXECUTOR_FRAGMENT}
  query ADMIN_EXECUTOR($where: AdminExecutorWhereInput!) {
    adminExecutor(where: $where) {
      ...ExecutorReturn
    }
  }
`;

export const ADMIN_UPDATE_EXECUTOR_STATUS = gql`
  ${EXECUTOR_FRAGMENT}
  mutation ADMIN_UPDATE_EXECUTOR_STATUS($where: UpdateExecutorWhereInput!, $data: AdminUpdateExecutorStatusInput!) {
    adminUpdateExecutorStatus(where: $where, data: $data) {
      ...ExecutorReturn
    }
  }
`;
